import { Component, OnInit,Input } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import * as moment from 'moment';
import {environment} from "../../environments/environment";

@Component({
  selector: 'app-general-daily-report',
  templateUrl: './general-daily-report.component.html',
  styleUrls: ['./general-daily-report.component.css']
})
export class GeneralDailyReportComponent implements OnInit {
  @Input() selectedRegion: string;
  @Input() selectedDistrict: string;

  public apiBaseUrl: string = environment.apiBaseUrl;
  route:string;
  regionLoader = false;
  closeIndustryList = [];
  regionList = [];
  industryList=[];
  vendorList=[];
  categoryList=[];
  timeUnitList=[];
  stationList=[]
  industryParameterList = [];
  regionFilter = '';
  start_date:any="";
  end_date:any="";
  aggregationFilter="1";
  timeIntervalFilter="1";
  categoryFilter="";
  unitTypeFilter="";
  vendorFilter="";
  industryFilter=[];
  stationFilter=[];
  startReportDate:Date;
  endReportDate = new Date();
  maxStartDate : Date;
  maxEndDate : Date;
  startReportTime: Date;
  endReportTime: Date;
  startDate:Date;
  endDate:Date;
  startTime = '';
  endTime = '';
  userData:any = [];
  currentRoute: any;
  userLevel: any;
  userName;
  searchField = {};
  industrySettings
  stationSettings
  disabled=false
  otherDetails={
    hr_ocmms_id: "",
    industry_name: "",
    industry_address: "",
    category_type: "",
    industry_category: "",
    industry_type: "",
    region: "",
    time_interval: "",
    end_date: "",
    start_date: "",
  }
  selectedIndustryId
  selectedVendorId
  timeIntervalArray=["Actual", "15 minute", "30 min", "Hourly", "Daily", "Monthly", "Quarterly", "Yearly"];
  constructor(private activeroute: ActivatedRoute,private router: Router,
              private _service: CommonService) {
    this.maxStartDate = new Date();
    this.maxEndDate = new Date();}


  initState = true;
  ngOnInit() {
    this.currentRoute = this.router.url.replace('/', '');
    this.userData = JSON.parse(localStorage.getItem('userData'));

    if (this.userData && this.userData['user_profile_id'] != undefined && this.userData['user_profile_id'] != 'IT001' && this.userData['user_profile_id'] != 'HSPCBCEMS') {
      this.router.navigate(['dashboard']);
    }

    if(this.userData){
      this.userName = this.userData['user_profile_id'];
      this.userLevel = this.userData['access_level'];
    }

      this.selectedIndustryId = this.userName;

      this.selectedVendorId = this.userData['id']?this.userData['id']:'';

    var date = new Date();
    this.startReportDate = date;
    this.getRegionList();
    this.settings();
   // this.getIndustryList();
   // this.getVendorList();
   // this.getCategoryList();
   // this.getTimeUnitList();
   // this.getStationList();
    // this.getReport();
  }
  settings(){
    this.industrySettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1
    };
    this.stationSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1
    };
  }


  onStartDateChange(value: Date): void {
    this.startReportDate = value;
    // this.endReportDate = this.startReportDate;
  }

  onEndDateChange(value: Date): void {
    this.endReportDate = value;
  }


  getReport(){
    this.initState=false
    if(this.startReportDate){
      if(this.startReportTime){
      } else{
        this.startReportTime=new Date;
          this.startReportTime.setMinutes(this.startReportTime.getMinutes() - 5);
      }
    }
    if(this.endReportDate){
      if(this.endReportTime){
      } else{
        this.endReportTime=new Date;
      }
    }
    if(this.startReportDate){
      var sdate = this.convertDateFormat(this.startReportDate);
    }

    if(this.endReportDate){
      var edate = this.convertDateFormat(this.endReportDate)
    }

    if(this.startReportTime){
      var stime = this.convertTimeFormat(this.startReportTime)
    }

    if(this.endReportTime){
      var etime = this.convertTimeFormat(this.endReportTime)
    }

    //this.startDate=this.combineDateTime(sdate,stime);
    //this.endDate=this.combineDateTime(edate,etime);
    if(sdate){
      if(stime){
        this.start_date = sdate + ' ' + stime;
      } else{
      }
    }
    if(edate){
      if(etime){
        this.end_date = edate + ' ' + etime;
      } else{
      }
    }
    this.regionLoader = true;
    this.route  = 'get-general-industry-daily-report';
    const token = localStorage.getItem('userToken');
    let data = { 'station_id':this.stationFilter.map((item)=>item.id).join(),
                'industry_id':this.industryFilter.map((item)=>item.id).join(),
                 'vendor_id':this.vendorFilter,
                 'unit_type':this.unitTypeFilter,
                 'category_type':this.categoryFilter,
                 'region':this.regionFilter,
                 'start_date':this.start_date,
                 'end_date':this.end_date,
                 'aggregation':this.aggregationFilter,
                 'time_interval':this.timeIntervalFilter
              };
    console.log(data);
    this.disabled=true
    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      console.log(response);
      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }

      if(response.status == 200){
        setTimeout(()=>{ this.closeIndustryList = response.result.data;
          this.otherDetails = response.result.otherDetails;
          console.log(this.otherDetails)},3000)

      }
      setTimeout(()=>{this.regionLoader = false;
        this.disabled=false},3000)

    });
  }


  region = "";
  industry_category = "";
  industry_type = "";
  vendorId = "";
  industry_id = "";
  station_id = "";

  getRegionList(){

    this.route  = 'get-region-list';
    const token = localStorage.getItem('userToken');

    let data = [];

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.regionList = response.data;
        this.regionFilter=this.regionList[0].region_name
        console.log(this.regionList);
       // if(this.initState){
         // this.getReport();
       //   this.initState = 0;
       // }
      }
      this.getCategoryList();
    }, error =>{
      this.getCategoryList();
    });
  }

  getCategoryList(region = null){


    this.route  = 'get-industry-categories';
    const token = localStorage.getItem('userToken');
    let data = {};
    if(region){
      this.region = region.target.value;
    } else{
      this.region = "";
    }
    data = {'region' : this.region};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.categoryList = response.data;
      }
      this.getTimeUnitList();
    }, error =>{
      this.getTimeUnitList();
    });

  }

  getTimeUnitList(industry_category = null){

    this.route  = 'get-industry-type';
    const token = localStorage.getItem('userToken');
    let data = {};
    if(industry_category){
      this.industry_category = industry_category.target.value;
    } else{
      this.industry_category = "";
    }
    data = {
      'region' : this.region,
      'industry_category' : this.industry_category
    };

    if(industry_category){
      data = {'industry_category' : industry_category.target.value};
    }
    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {
      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.timeUnitList = response.data;
      }
      this.getVendorList();
    }, error =>{
      this.getVendorList();
    });
  }

  getVendorList(industry_type = null){
    this.route  = 'get-vendor-list';
    const token = localStorage.getItem('userToken');
    let data = {};
    if(industry_type){
      this.industry_type = industry_type.target.value;
    } else{
      this.industry_type = "";
    }
    data = {
      'region' : this.region,
      'industry_category' : this.industry_category,
      'industry_type' : this.industry_type,
      'vendor_id':this.vendorFilter,
    };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        let vendorListM = response.data;
        if(this.selectedVendorId)
          this.vendorList = vendorListM.filter((item)=>item.id==this.selectedVendorId)
        else
          this.vendorList = vendorListM

      }
      this.getIndustryList();
    }, error =>{
      this.getIndustryList();
    });
  }

  getIndustryList(vendor_id = null){
    this.industryFilter=[];
    this.route  = 'get-all-industry-details';
    const token = localStorage.getItem('userToken');

    let data = {};
    if(vendor_id){
      this.vendorId = vendor_id.target.value;
    } else{
      this.vendorId = "";
    }

    let search_fields = {
      'region' : this.region,
      'categoryType' : this.industry_category,
      'industryType' : this.industry_type,
      'vendorId' : this.vendorId
    };

    this.userData = JSON.parse(localStorage.getItem('userData'));

    if(this.userData){
      this.userName = this.userData['user_profile_id'];
      this.userLevel = this.userData['access_level'];
    }

    if(this.userLevel == 'industry'){
      search_fields['industryId'] = this.userName;
    }

    if(this.userLevel == 'vendor'){
      search_fields['vendorId'] = this.userData['id']?this.userData['id']:'';
    }

    data = {'search_fields' : search_fields}
    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        let industryListM = response.data;
        this.industryList = industryListM;
        // this.industryList=industryListM.filter((item)=>this.selectedIndustryId==item.code)
      }
      this.getStationList();
    }, error =>{
      this.getStationList();
    });
  }

  getStationList(industryid=null ,all=null){
    console.log(industryid ,"mm")
     this.stationFilter=[]
    this.route  = 'get-ind-station-details';
    const token = localStorage.getItem('userToken');
    let data = {};
    if(all){
      this.industryFilter=industryid
    }
    if(industryid){
      this.industry_id = this.industryFilter.map((item)=>item.id).join();;
    } else{
      this.industry_id = "";
    }
    console.log(this.industryFilter,"F")
    console.log(this.industry_id,"id")
    data = {
      'region' : this.region,
      'industry_category' : this.industry_category,
      'industry_type' : this.industry_type,
      'vendor_id' : this.vendorId,
      'industry_id' : this.industry_id
    };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.stationList = response.data;
      }
    }, error =>{
    });
  }

  convertDateFormat(dateObj) {

    var result_date = new Date(dateObj);

    var str = result_date.getFullYear() + '-' +
        ((result_date.getMonth()+1) > 9 ? (result_date.getMonth()+1) : ('0'+(result_date.getMonth()+1)))
        + '-' +
        (result_date.getDate() > 9 ? result_date.getDate() : ('0'+result_date.getDate()));

    return str;
  }

  convertTimeFormat(timeObj) {

    if(timeObj){
      var result_time = new Date(timeObj);

      return ((result_time.getHours()) > 9 ? (result_time.getHours()) : ('0'+(result_time.getHours()))) + ':' + ((result_time.getMinutes()) > 9 ? (result_time.getMinutes()) : ('0'+(result_time.getMinutes()))) + ':00';
    }else{
      return '00:00:00'
    }
  }
  combineDateTime(day,time){
    var newDate = new Date(day+"T"+time);
    return newDate;
  }
  exportReport(type){
    var a;
    const token = localStorage.getItem('userToken');

    a = document.getElementById('export'+type+'href');
    a.href = this.apiBaseUrl +"/general-industry-daily-export/"+type +"/"+token
      +"?industry_id="+(this.industryFilter ? btoa(this.industryFilter.map((item)=>item.id).join()) : btoa(null))
      +"&vendor_id="+(this.vendorFilter ? btoa(this.vendorFilter) : btoa(null))
      +"&unit_type="+(this.unitTypeFilter ? btoa(this.unitTypeFilter) : btoa(null))
      +"&category_type="+(this.categoryFilter ? btoa(this.categoryFilter) : btoa(null))
      +"&region="+(this.regionFilter ? btoa(this.regionFilter) : btoa(null))
      +"&start_date="+(this.start_date ? btoa(this.start_date) : btoa(null))
      +"&end_date="+(this.end_date ? btoa(this.end_date) : btoa(null))
      +"&aggregation="+(this.aggregationFilter ? btoa(this.aggregationFilter) : btoa(null))
      +"&time_interval="+(this.timeIntervalFilter ? btoa(this.timeIntervalFilter) : btoa(null))
      +"&station_id="+(this.stationFilter ? btoa(this.stationFilter.map((item)=>item.id).join()) : btoa(null))
      ;
    document.getElementById('export'+type+'href').click();
    }

}
